export default __webpack_public_path__ + "static/media/Spin torre RD_Interactive LightMix0033.8cce14b5.webp";